import React, { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import Logo from '../assets/MALogo.svg';
import { jwtDecode } from 'jwt-decode';

const EmailVerification = () => {
  const [tokenDB, setTokenDB] = useState('');
  const [type, setType] = useState('');
  const [userId, setUserId] = useState('');
  const [username, setUsername] = useState('');
  const [searchParams] = useSearchParams();
  const [message, setMessage] = useState('');
  const [isLoading, setIsLoading] = useState(true);

  const token = searchParams.get('token'); // Extract the token from the URL

  const navigate = useNavigate();

  const getDecodedData = () => {
      try {
        if (!token) return null;
        const decoded = jwtDecode(token);
        return {
          token: decoded.token,
          userId: decoded.userId,
          username: decoded.username,
          type: decoded.type
        };
    } catch (error) {
        console.error('Invalid token format:', error);
        return null;
    }
  };

  // Refresh the tokens if the user is logged in
  const refreshCookies = async () => {
    const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/auth/refresh`, {
      method: 'GET',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json',
        'Cache-Control': 'no-cache',
      },
    });

    const data = await response.json();

    if(data.success === true) {
      console.log("Session refreshed successfully");
    } else {
      console.log("Error refreshing session");
    }
  };

  const verifyEmail = async () => {
    try {
      const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/user/verify?token=${tokenDB}&type=${type}&userId=${userId}&username=${username}`, {
        method: 'GET',
      });

      const data = await response.json();

      if (data.success) {
        setMessage('Your email has been successfully verified!');
      } else {
        setMessage(data.message || 'Failed to verify email.');
      }
    } catch (error) {
      console.error('Error verifying email:', error);
      setMessage('An error occurred while verifying your email.');
    }
  };

  const handleVerification = async () => {
    if (!tokenDB || !type || !userId || !username) {
      return;
    }

    if (tokenDB && type && userId && username) {
      await verifyEmail();
      if (type !== 'signup') {
        // only needed if type is not signup
        // Will refresh cookies if user is logged in to avoid stale session info
        await refreshCookies(); 
      }
    } else {
      setMessage('Invalid verification link.');
    }
    setIsLoading(false);
  };

  useEffect(() => {
    const decodedData = getDecodedData();
    if (decodedData) {
      setTokenDB(decodedData.token);
      setType(decodedData.type);
      setUserId(decodedData.userId);
      setUsername(decodedData.username);
    } else {
      setMessage('Invalid verification link.');
      setIsLoading(false);
    }
  }, [token]);

  useEffect(() => {
    handleVerification();
  }, [tokenDB, type, userId, username]);

  return (
    <div className="wrapper">
        <div className="d-flex justify-content-center landscape-spacing" style={{paddingTop: "40px", cursor: "pointer"}} onClick={() => navigate('/')}>
            <img src={Logo} alt="Melee Academy Logo" style={{width: "50px", marginRight: "12px"}}/>
            <h2 style={{fontWeight: 600}}>Melee Academy</h2>
        </div>

        {isLoading ? (
          <div className='background-grid d-flex flex-column justify-content-center align-items-center landscape-spacing' style={{minHeight: "80vh"}}>
            <div className='d-flex flex-column custom-container text-center'>
                <div style={{
                    width: '60px',
                    height: '60px',
                    border: '6px solid #f3f3f3',
                    borderTop: '6px solid #FFCC19',
                    borderRadius: '50%',
                    animation: 'spin 1s linear infinite',
                    margin: '0 auto 20px'
                }}></div>
                <h2 style={{fontWeight: 400}}>Verifying Token...</h2>
                <style>{`
                    @keyframes spin {
                        0% { transform: rotate(0deg); }
                        100% { transform: rotate(360deg); }
                    }
                `}</style>
            </div>
        </div>
        ) : (
          <div className='background-grid d-flex flex-column justify-content-center align-items-center' style={{minHeight: "80vh"}}>
              <div className='d-flex flex-column custom-container'>
                  <h2 className='pb-3 text-center' style={{fontWeight: 400}}>Email Verification</h2>
                  <p className='text-center'>{message}</p>
              </div>
          </div>
        )}
    </div>
  );
};

export default EmailVerification;